import { render } from "./field-datepicker.vue?vue&type=template&id=0f8a27d2"
import script from "./field-datepicker.vue?vue&type=script&lang=js"
export * from "./field-datepicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__